<template>
	<div class="shop-container content-wrap" >
	<!-- v-loading.fullscreen="loading" -->
		<swiper-small :list="bannerArr"/>
		<div class="container bgw">
			<div class="filter-box">
			<div class="filter-list-wrap">
				<div class="filter-list-head">分类：</div>
				<div class="filter-list">
					<div class="filter-item"  v-for="item in filterClassComputed(videoMenu,'class')" :key="item.id" @click="selectCat(item.id,item.pid)" :class="selectedTypeId==item.id?'active':''">{{item.type_name}}</div>
				</div>
				<div class="more" @click="showMoreClass=!showMoreClass" v-if="videoMenu.length>6">更多
					<i class="icon iconfont iconxjt" :class="{'top':showMoreClass}"></i>
				</div>
			</div>
			</div>
		</div>
		<div class="list-wrap">
		<div class="list-item"  v-for="item in list" :key="item.id"> 
			<router-link class="pic" tag="a" :to="{name: 'videodetail', params: {videoId: item.id}}">
				<img :src="item.cover" alt="" class="pic">
			</router-link>
			<div class="title">{{item.title}}</div>
			<div class="bot">
				<div class="view">{{$t('views')}}：{{item.pv}}</div>
				<div class="date">{{$t('date')}}：{{item.ctime}}</div>
			</div>
		</div>
		</div>

      <template v-if="list.length>0">
        <Pagination
            :totalPage="totalPage"
            :limit="form.limit"
            @changePage="handleCurrentChange"
        ></Pagination>
    </template>
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";
import SwiperSmall from '@/components/common/SwiperSmallVideo.vue'
import { deepCopy } from "@/utils";
export default {
    components: { Pagination, SwiperSmall },
    data() {
        return {
            list: [],
            form: {
                page: 1,
                limit: 9
            },
            totalPage: 0,
            bannerArr: [],
            loading: false,
			videoMenu:[],
			selectedTypeId:'',
			showMoreClass: false
        }
    },
    watch: {
        $route(to, from) {
            let query = this.$route.query;
            if(query.search_name) {
                delete this.form.id
                this.selectName(query.search_name)
            } else {
                this.form.id =  this.$route.query.id
                this.form.pid =  this.$route.query.pid
				this.form.page = 1
				this.list = []
                this.init(query);
            }
        }
    },
    created() {
        let query = this.$route.query;
        if(this.$route.query.id) {
            this.form.id =  this.$route.query.id
        }
        if(this.$route.query.pid) {
            this.form.pid =  this.$route.query.pid
        }
        if(query.search_name) {
            this.selectName(query.search_name)
        } else {
            this.form.id =  this.$route.query.id
            this.form.pid =  this.$route.query.pid
            this.init(query);
        }
        this.getBanner()
		this.videoclassify()
		
    },
	computed: {
		filterClassComputed() {
		  return (list, type) => {
			if (list.length < 7) {
			  return list;
			}
			if (type == "class") {
			  if (this.showMoreClass) {
				return list;
			  }
			}
			return list.slice(0, 6);
		  };
		}
	},
    methods: {
        // 获取轮播图s
        getBanner() {
            this.$api.slider({
                code: 'pc_video_home_slide'
            }).then(res => {
                if (res.status) {
                    this.bannerArr = res.data.list;
                }
            });
        },
        selectName(name) {
            this.setSearchOptions(name, true);
            this.getList();
        },
		// 获取视频分类
		videoclassify() {
		  this.$api.gettypetist({id:this.form.id}).then(res => {
			if(res.status) {
			  this.videoMenu =  res.data.list.child || res.data.list[0].child;
			}
		  })
		},
		//搜索分类
		selectCat(id,pid) {
            this.form.id =  id;
            this.form.pid =  pid;
			this.form.page =  1;
			this.selectedTypeId =  id;
            this.loading = true
			this.list = [];
            this.$api.getcourselist(this.form).then(res => {
                setTimeout(() =>{
                    this.loading = false
                }, 500)
                if(res.status) {
					if(res.data.list.length>0){
						this.list = res.data.list[0].course.list
						this.totalPage = Math.ceil(res.data.list[0].course.count / this.form.limit) 
						//console.log(this.totalPage, '----', res.data.list[0].course.count , '-----',  this.form.limit)
					}
                }
            })
		},
        getList() {
            this.loading = true
            this.$api.courseGetlist(this.form).then(res => {
                setTimeout(() =>{
                    this.loading = false
                }, 500)
                if(res.status) {
						this.list = res.data.list[0].course.list
						this.totalPage = Math.ceil(res.data.list[0].course.count / this.form.limit) 
                    //console.log(this.totalPage, '----', res.data.count , '-----',  this.form.limit)
                }
            })
        },
        //设置筛选条件
        setSearchOptions: function(name, clear = false) {

            var sd = this.form;
            this.form = {
                ...this.form,
                where: JSON.stringify({search_name: name})
            } 
            //console.log(this.form)

            if (clear) {
                this.list = [];
            }
        },
        handleCurrentChange(v) {
            this.form.page = v
            this.init()
            this.scrollToTop()
        },
        scrollToTop() {
            document.body.scrollTop = document.documentElement.scrollTop = 0
        },
        init() {
            this.loading = true
            this.$api.getcourselist(this.form).then(res => {
                setTimeout(() =>{
                    this.loading = false
                }, 500)
                if(res.status) {
					if(res.data.list.length>0){
						this.list = res.data.list[0].course.list
						this.totalPage = Math.ceil(res.data.list[0].course.count / this.form.limit) 
						//console.log(this.totalPage, '----', res.data.list[0].course.count , '-----',  this.form.limit)
					}
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
@import '@/assets/css/variable.scss';
.content-wrap {
    background: #ffffff;
	
  .container {
    background: #fff;
    padding: 4px 18px;
    margin: 20px 0;
    .filter-box {
      margin: 0 auto;
      font-size: 14px;
      .filter-list-wrap {
        position: relative;
        padding-left: 72px;
        transition: height 0.25s linear;
        border-bottom: 1px dashed $border;
        &.open {
          .filter-list {
            height: 120px;
          }
        }
        .filter-list-head {
          width: 72px;
          position: absolute;
          left: 0;
          top: 14px;
          color: #b0b0b0;
        }
        .filter-list {
          display: flex;
          flex-flow: row wrap;
          padding-right: 60px;
          .filter-item {
            min-width: 140px;
            height: 20px;
            line-height: 20px;
            padding: 12px 0;
            cursor: pointer;
            padding-right: 30px;
            &.active {
              color: $theme-color;
            }
          }
        }
        .more {
          position: absolute;
          right: 0;
          top: 8px;
          height: 24px;
          line-height: 24px;
          color: #757575;
          cursor: pointer;
          user-select: none;
          &:hover {
            color: $theme-color;
          }
          .icon {
            display: inline-block;
            transition: all 0.2s;
            &.top {
              transform: rotate(180deg);
            }
          }
        }
      }
    }
  }
	
	
    .list-wrap {
        width: 1226px;
        margin: 0 auto;
        padding: 20px 12px;
        display: flex;
        flex-wrap: wrap;
        .list-item {
            padding: 11px;
            width: 370px;
            background: #fff;
            border: 1px solid #e5e5e5;
            transition: all 0.2s linear 0s;
            box-shadow: 2px 2px 4px #e3e3e3;
            position: relative;
            margin-bottom: 12px;
            margin-left: 12px;
            &:nth-child(3n + 1 ) {
                margin-left: 0;
            }
            &:hover {
                box-shadow: 0 15px 20px rgba(0,0,0,0.1);
            }
            .pic {
                width: 370px;
                height: 216px;
            }
            .title {
                line-height: 40px;
                @include no-wrap();
            }
            .bot {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
        }
    }
}

</style>

<style lang="scss">
.page-box .el-pagination {
    padding-bottom: 20px;
}
</style>